<div
  class="d-block alarm-list-card pt-2"
  [class.expanded]="expanded"
  (click)="onClick()"
>

    <div class="d-flex align-items-center justify-content-between w-100 alarm-list-header px-2">
      <i
        class="far alarm-list-chevron text-primary px-1"
        [class.fa-chevron-up]="expanded"
        [class.fa-chevron-down]="!expanded"
        aria-hidden="true"
        (click)="$event.stopPropagation(); onChevronClick()"
      ></i>

      <lib-chip-group
        class="d-block flex-grow-1"
        [options]="alarmCategoryChips"
        type="target"
        (chipsChange)="onAlarmCategoriesChange($event)"
      ></lib-chip-group>

      @if (expanded) {
        <span
          class="ml-2 alarm-list-close"
          (click)="$event.stopPropagation()"
        >
          <lib-button
            faIcon="far fa-times"
            size="custom"
            [width]="'28px'"
            [height]="'28px'"
            [fontSize]="18"
            color="primary-link"
            (buttonClicked)="onClose()"
          ></lib-button>
        </span>
      }
    </div>

  @if (expanded) {
    <div>
      <div class="alarm-list-separator"></div>
      <div class="alarm-list-table-wrapper">
        <table class="table table-striped table-borderless mb-0 w-100">
          <thead class="text-primary font-weight-bold">
            <tr>
              <th>{{ 'COMMON.CATEGORY' | translate }}</th>
              <th class="text-left">{{ 'PERFORMANCE_MONITORING.WIND_TURBINE' | translate }}</th>
              <th class="text-left">{{ 'PERFORMANCE_MONITORING.ALARM_CODE' | translate }}</th>
              <th class="text-left">{{ 'PERFORMANCE_MONITORING.START_TIME' | translate }}</th>
              <th aria-label="Open alarm"></th>
            </tr>
          </thead>

          <tbody class="text-primary font-weight-bold">
            @for (alarm of filteredAlarms; track $index) {
              <tr>
                <td>
                  @if (alarm?.alarmCategory) {
                    <i
                      class="fas fa-circle mr-2"
                      [style.color]="getAlarmCategoryColor(alarm?.alarmCategory)"
                      [matTooltip]="getAlarmCategoryLabel(alarm?.alarmCategory) | translate"
                    ></i>
                  } @else {
                    {{ 'COMMON.NO_DATA' | translate }}
                  }
                </td>

                <td class="text-left">
                  @if (alarm?.turbine?.code && alarm?.turbine?.serialNav != null) {
                    {{ alarm.turbine.code | noUnderscore }} ({{ alarm.turbine.serialNav }})
                  } @else {
                    {{ 'COMMON.NO_DATA' | translate }}
                  }
                </td>

                <td class="text-left">{{ alarm?.code || ('COMMON.NO_DATA' | translate) }}</td>

                <td class="text-left">
                  @if (alarm?.createTS != null) {
                    {{ alarm.createTS | dateTimeFormatPipe: 'dmt' : timezone }}
                  } @else {
                    {{ 'COMMON.NO_DATA' | translate }}
                  }
                </td>

                <td class="text-right">
                  @if (canOpenAlarm(alarm)) {
                    <span (click)="$event.stopPropagation()">
                      <lib-button
                        faIcon="fas fa-external-link-alt"
                        size="custom"
                        color="primary-link"
                        (buttonClicked)="openAlarm(alarm)"
                      ></lib-button>
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
